import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, NavLink } from "react-router-dom";
import welcomeCover from "../images/welcomeCover.svg";
import welcomeCover2 from "../images/welcomeCover2.svg";
import welcomeCover3 from "../images/welcomeCover3.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
};

function WelcomeSettings() {

  return (
    <>
      <div className="settings-form">
        <div className="modalItem-respNav">

          <Link to="/" className="okkiLogoMobile">
            <div>
              <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M45.5925 39.8231C46.9383 39.8904 48.0654 38.8137 48.0654 37.468V35.1633C48.0654 34.8773 48.4019 34.7259 48.6206 34.9109L53.9869 39.3016C54.4243 39.6549 54.9458 39.8399 55.4841 39.8399C56.1738 39.8399 56.8467 39.5371 57.3009 38.982C58.1252 37.9726 57.9738 36.4923 56.9645 35.668L52.4224 31.9502C52.086 31.681 52.086 31.1764 52.4224 30.9072L56.9645 27.1894C57.9738 26.3651 58.1252 24.8848 57.3009 23.8754C56.4766 22.8661 54.9963 22.7147 53.9869 23.539L48.6206 27.9296C48.4019 28.1147 48.0654 27.9465 48.0654 27.6773V25.4231C48.0654 24.1614 47.0897 23.068 45.828 23.0007C44.4822 22.9334 43.3551 24.01 43.3551 25.3558V37.4007C43.3551 38.6623 44.3308 39.7558 45.5925 39.8231ZM36.4075 42.1782C35.0617 42.1109 33.9346 43.1876 33.9346 44.5334V46.838C33.9346 47.124 33.5981 47.2754 33.3794 47.0904L28.0131 42.6997C27.5757 42.3465 27.0542 42.1614 26.5159 42.1614C25.8262 42.1614 25.1533 42.4642 24.6991 43.0194C23.8748 44.0287 24.0262 45.5091 25.0355 46.3334L29.5776 50.0511C29.914 50.3203 29.914 50.825 29.5776 51.0941L25.0355 54.8119C24.0262 55.6362 23.8748 57.1165 24.6991 58.1259C25.5234 59.1352 27.0037 59.2866 28.0131 58.4623L33.3794 54.0717C33.5981 53.8866 33.9346 54.0549 33.9346 54.324V56.5614C33.9346 57.8231 34.9103 58.9165 36.172 58.9838C37.5178 59.0511 38.6449 57.9745 38.6449 56.6287V44.5838C38.6449 43.339 37.6692 42.2455 36.4075 42.1782ZM31.4112 23.0007C26.7682 23.0007 23 26.7689 23 31.4119C23 36.0549 26.7682 39.8231 31.4112 39.8231C36.0542 39.8231 39.8224 36.0549 39.8224 31.4119C39.8224 26.7689 36.0542 23.0007 31.4112 23.0007ZM31.4112 35.1128C29.3757 35.1128 27.7103 33.4474 27.7103 31.4119C27.7103 29.3764 29.3757 27.7109 31.4112 27.7109C33.4467 27.7109 35.1121 29.3764 35.1121 31.4119C35.1121 33.4474 33.4467 35.1128 31.4112 35.1128ZM56.6449 48.2343H44.5327C43.2374 48.2343 42.1776 49.2941 42.1776 50.5894C42.1776 51.8848 43.2374 52.9446 44.5327 52.9446H56.6449C57.9402 52.9446 59 51.8848 59 50.5894C59 49.2941 57.9402 48.2343 56.6449 48.2343Z" fill="black" />
              </svg>
              {/* <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0)">
                                            <path d="M20.0822 14.9535C21.2785 15.0133 22.2804 14.0563 22.2804 12.86V10.8114C22.2804 10.5572 22.5794 10.4226 22.7738 10.5871L27.5439 14.4899C27.9327 14.804 28.3963 14.9684 28.8748 14.9684C29.4879 14.9684 30.086 14.6993 30.4897 14.2058C31.2224 13.3086 31.0878 11.9927 30.1907 11.26L26.1533 7.95536C25.8542 7.7161 25.8542 7.26751 26.1533 7.02825L30.1907 3.72358C31.0878 2.99087 31.2224 1.67498 30.4897 0.777788C29.757 -0.119409 28.4411 -0.253988 27.5439 0.478722L22.7738 4.38153C22.5794 4.54601 22.2804 4.39648 22.2804 4.15723V2.15349C22.2804 1.03199 21.4131 0.0600306 20.2916 0.000217531C19.0953 -0.0595955 18.0935 0.897414 18.0935 2.09368V12.8002C18.0935 13.9217 18.9607 14.8937 20.0822 14.9535ZM11.9178 17.0469C10.7215 16.9871 9.71963 17.9441 9.71963 19.1404V21.189C9.71963 21.4432 9.42056 21.5778 9.22617 21.4133L4.45607 17.5105C4.06729 17.1965 3.60374 17.032 3.12523 17.032C2.51215 17.032 1.91402 17.3011 1.51028 17.7946C0.77757 18.6918 0.91215 20.0077 1.80935 20.7404L5.84673 24.0451C6.14579 24.2843 6.14579 24.7329 5.84673 24.9722L1.80935 28.2768C0.91215 29.0096 0.77757 30.3254 1.51028 31.2226C2.24299 32.1198 3.55888 32.2544 4.45607 31.5217L9.22617 27.6189C9.42056 27.4544 9.71963 27.604 9.71963 27.8432V29.832C9.71963 30.9535 10.5869 31.9254 11.7084 31.9853C12.9047 32.0451 13.9065 31.0881 13.9065 29.8918V19.1853C13.9065 18.0787 13.0393 17.1068 11.9178 17.0469ZM7.47664 0.000217531C3.34953 0.000217531 0 3.34975 0 7.47685C0 11.604 3.34953 14.9535 7.47664 14.9535C11.6037 14.9535 14.9533 11.604 14.9533 7.47685C14.9533 3.34975 11.6037 0.000217531 7.47664 0.000217531ZM7.47664 10.7666C5.66729 10.7666 4.18692 9.2862 4.18692 7.47685C4.18692 5.66751 5.66729 4.18713 7.47664 4.18713C9.28598 4.18713 10.7664 5.66751 10.7664 7.47685C10.7664 9.2862 9.28598 10.7666 7.47664 10.7666ZM29.9065 22.4301H19.1402C17.9888 22.4301 17.0467 23.3722 17.0467 24.5236C17.0467 25.675 17.9888 26.617 19.1402 26.617H29.9065C31.0579 26.617 32 25.675 32 24.5236C32 23.3722 31.0579 22.4301 29.9065 22.4301Z" fill="#111111" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0">
                                                <rect width="32" height="32" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg> */}


            </div>
          </Link>

        </div>
        <div className="settings-form__welcomeSlider">
          <Slider {...sliderSettings}>
            <div>
              <div className="modal-content modal-contentWelcome">
                <div className="modal-text">
                  <div className="modal-cover">
                    <img src={welcomeCover} />
                  </div>

                  <h3 className="modal-title">Bienvenidx a Okki</h3>
                  <p className="modal-text">
                    Utiliza Okki de forma gratuita o utiliza las herramientas PRO que ofrecemos para exponenciar tu negocio
                </p>
                  <br />
                </div>
              </div>
            </div>
            <div>
              <div className="modal-content modal-contentWelcome">
                <div className="modal-text">
                  <div className="modal-cover">
                    <img src={welcomeCover2} />
                  </div>

                  <h3 className="modal-title">Vende sin comisiones</h3>
                  <p className="modal-text">
                    Tú decides como cobrar y como enviar, tus clientes te contactarán por Whatsapp.

               </p>
                  <br />
                </div>
              </div>
            </div>
            <div>
              <div className="modal-content modal-contentWelcome">
                <div className="modal-text">
                  <div className="modal-cover">
                    <img src={welcomeCover3} />
                  </div>

                  <h3 className="modal-title">El negocio es tuyo</h3>
                  <p className="modal-text">
                    Crea tu tienda en línea y comienza a vender hoy mismo.
            </p>
                  <br />
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>

    </>
  );
}

export default WelcomeSettings;